import { render } from "./Carousel2.vue?vue&type=template&id=8da4952c&scoped=true&ts=true"
import script from "./Carousel2.vue?vue&type=script&lang=ts"
export * from "./Carousel2.vue?vue&type=script&lang=ts"

import "./Carousel2.vue?vue&type=style&index=0&id=8da4952c&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8da4952c"]])

export default __exports__